/**
 * Authentication Client for JourFx Client (Versicherten) Portal
 * Uses portal session authentication for Versicherte
 */
import { createAuthClient } from "better-auth/react";
import {
  convexClient,
  crossDomainClient,
} from "@convex-dev/better-auth/client/plugins";

function getAuthClientEndpoint(siteUrl?: string) {
  const fallback = "http://localhost:3211";

  if (!siteUrl) {
    return { baseURL: fallback, basePath: "/api/auth" };
  }

  try {
    const parsed = new URL(siteUrl);
    const path = parsed.pathname.replace(/\/+$/, "");

    if (!path || path === "/") {
      return { baseURL: parsed.origin, basePath: "/api/auth" };
    }

    if (path.endsWith("/api/auth")) {
      return { baseURL: parsed.origin, basePath: path };
    }

    if (path.endsWith("/http")) {
      return { baseURL: parsed.origin, basePath: `${path}/api/auth` };
    }

    return { baseURL: parsed.origin, basePath: path };
  } catch {
    return { baseURL: fallback, basePath: "/api/auth" };
  }
}

const authEndpoint = getAuthClientEndpoint(import.meta.env.VITE_CONVEX_SITE_URL);

// Create better-auth client with Convex plugins
export const authClient = createAuthClient({
  baseURL: authEndpoint.baseURL,
  basePath: authEndpoint.basePath,
  plugins: [convexClient(), crossDomainClient()],
});

// Export auth hooks and methods
export const {
  signIn,
  signOut,
  useSession,
  getSession,
} = authClient;

// Types for versicherten session
export interface VersichertenSession {
  appointmentId: string;
  versichertenName: string;
  expiresAt: Date;
}
